import { type FC, useContext } from "react";
import { type TableColumnMap, TableComponent } from "../../Forms/DragDrop/ComponentBases/TableComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue } from "../../Forms/DragDrop/ReorderableTableSettings";

const COLUMN_DEFINITIONS: TableColumnMap = {
    payment: {
        style: {
            textAlign: "right",
        },
    },
    amount: {
        style: {
            width: "6em",
        },
    },
};

export const ReceiptPaymentTableComponent: FC<ComponentOptions> = ({
    style,
    value,
}) => {
    const { payments } = useContext(DragDropDataContext);

    if(!Array.isArray(payments)) {
        return null;
    }

    if(!hasColumnsValue(value)) {
        return null;
    }

    return (
        <TableComponent
            noHeader
            columns={COLUMN_DEFINITIONS}
            value={value.columns}
            data={payments}
            style={style}
        />
    );
};
